import React, { useContext } from 'react';
import { Avatar, Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { LanguageContext } from '../../../../../../../../../libs/Context';

const SpeakersCard = (props) =>
{
	const { speakerData, data } = props;
	const { language } = useContext(LanguageContext);
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));

	return (

		<Grid container spacing={2} py='var(--pixel16)'>
			<Grid item xs={12} sm={6} lg={4}>
				<Grid container spacing={2} alignItems='start'>
					<Grid item>
						<Stack direction={'column'} alignItems={'center'} spacing={1}>
							<Avatar src='https://wallpapercave.com/wp/wp4807592.jpg' sx={{ height: downSM ? 40 : 48, width: downSM ? 40 : 48 }} />
						</Stack>
					</Grid>
					<Grid item>
						<Stack spacing={0.5}>
							<Typography variant='subtitle2'>{data?.meetingDetails?.hostName ?? ''}</Typography>
							<Typography fontSize={'var(--pixel12)'} color={'var(--txtColorBlackL)'} fontWeight='var(--font500)'>{language?.host}</Typography>
							{/* <Typography variant='body2' fontWeight='500' 
								noWrap>Founder at Meetup Now</Typography>
								<Stack direction='row' spacing={1} p='var(--pixel8)'>
									<Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='images/icons/facebook.svg' />
									<Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='/images/icons/linkedIn.svg' />
									<Avatar sx={{ height: 23, width: 23 }} 
									variant='rounded' src='/images/icons/instagramNew.svg' />
								</Stack> */}
						</Stack>
					</Grid>
				</Grid>
			</Grid>
			{speakerData?.map((card) => (
				<Grid item key={card?._id} xs={12} sm={6} lg={4} mb={1}>
					<Grid container spacing={2} alignItems='start'>
						<Grid item>
							<Stack direction={'column'} alignItems={'center'} spacing={1}>
								<Avatar src='https://wallpapercave.com/wp/wp4807592.jpg' sx={{ height: downSM ? 40 : 48, width: downSM ? 40 : 48 }} />
							</Stack>
						</Grid>
						<Grid item xs>
							<Stack spacing={0.5}>
								<Typography variant='subtitle2'>{card?.speakerName ?? ''}</Typography>
								<Typography fontSize={'var(--pixel12)'} color={'var(--txtColorBlackL)'} fontWeight='var(--font500)'>{language?.speakers}</Typography>
								<Typography variant='body2' fontWeight='500' noWrap>{card?.designation ?? ''}</Typography>
								{(card?.facebookUrl || card?.linkedinUrl || card?.websiteUrl) &&
									<Stack direction='row' spacing={1} pt='var(--pixel8)'>
										{card?.facebookUrl && <Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='images/icons/facebook.svg' />}
										{card?.linkedinUrl && <Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='/images/icons/linkedIn.svg' />}
										<Avatar sx={{ height: 23, width: 23 }} variant='rounded' src='/images/icons/instagramNew.svg' />
									</Stack>}
							</Stack>
						</Grid>
					</Grid>
				</Grid>
			))}
		</Grid>

	);
};

export default SpeakersCard;